__turbopack_context__.v({
  "actions": "error-module__bSZLSW__actions",
  "container": "error-module__bSZLSW__container",
  "content": "error-module__bSZLSW__content",
  "description": "error-module__bSZLSW__description",
  "errorCode": "error-module__bSZLSW__errorCode",
  "homeButton": "error-module__bSZLSW__homeButton",
  "retryButton": "error-module__bSZLSW__retryButton",
  "title": "error-module__bSZLSW__title",
  "wrapper": "error-module__bSZLSW__wrapper",
});
